import { Button, IconButton, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../api/auth/orders";
import create from "../../api/auth/orders/create";
import { useNavigate } from "react-router-dom";
import WushSortableTable from "../../components/layout/WushSortableTable";
import { Delete, Edit } from "@mui/icons-material";
import useOrderStore from "../../stores/useOrderStore";
import destroy from "../../api/auth/orders/destroy";
import search from "../../api/auth/orders/search";
import DeleteConfirmation from "../../components/form/DeleteConfirmation";
import { format } from "date-fns";
import OrderStatusChip from "../../components/displays/orders/OrderStatusChip";
import WushTextField from "../../components/form/WushTextField";

export default function Orders() {
  const [filter, setFilter] = useState('confirmed');
  const [filteredOrders, setFilteredOrders] = useState([]);

  const { orders, setOrders, addOrder, removeOrder, ordersByStatuses } = useOrderStore();
  const [ query, setQuery ] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    index((response) => {
      setOrders(response);
    });
  }, []);

  const handleCreate = () => {
    create({ test: 'value' }, (response) => {
      addOrder(response);
      navigate(`/orders/${response.id}`);
    });
  };

  const handleDelete = (order) => {
    destroy(order.id, () => {
      removeOrder(order);
    });
  };

  const handleSearch = () => {
    search(query, (response) => {
      console.log(response);
      setOrders(response);
      setFilteredOrders(response);
    });
  };

  useEffect(() => {
    console.log(filter);
    if (filter === 'all') {
      setFilteredOrders(orders);
    } else if (filter === 'confirmed') {
      setFilteredOrders(ordersByStatuses(['confirmed', 'paid']));
    } else if (filter === 'customer_drafts') {
      setFilteredOrders(ordersByStatuses(['draft']));
    }
  }, [filter, orders]);

  return (
    <Stack>
      <Stack mb={2}>
        <Typography variant="h4">Orders</Typography>
      </Stack>
      <Stack direction="row" mb={2}>
        <Button onClick={handleCreate} variant="contained" color="primary">Create Order</Button>
      </Stack>
      <Stack direction="row">
        <Stack direction="row" mb={2} gap={2} width="40%">
          <WushTextField
            onEnterPress={handleSearch}
            width="500px"
            label="Search"
            placeholder="Search by order ID, customer name, email, or phone number"
            formRegistration={{ onChange: (e) => setQuery(e.target.value) }}
          />
          <Button onClick={handleSearch} variant="outlined" color="primary">Search</Button>
        </Stack>
        <Stack width="60%" justifyContent="right">
          <ToggleButtonGroup
            color="primary"
            value={filter}
            exclusive
            onChange={(e) => setFilter(e.target.value)}
            aria-label="Platform"
            size="small"
            sx={{ ml: 'auto' }}
          >
            <ToggleButton value="confirmed" key="confirmed">Confirmed ({ordersByStatuses(['confirmed', 'paid']).length})</ToggleButton>
            <ToggleButton value="customer_drafts">Drafts ({ordersByStatuses('draft', 'review').length})</ToggleButton>
            <ToggleButton value="all">All ({orders.length})</ToggleButton>
          </ToggleButtonGroup>
        </Stack>

      </Stack>
      <Stack>
        <WushSortableTable
          onRowClick={(row) => navigate(`/orders/${row.id}`)}
          headers={[
            {
              label: "ID",
              key: "id"
            },
            {
              label: "Customer",
              key: "customer_id",
              customValue: (row) => <Stack>
                <Typography>{row.customer?.full_name}</Typography>
                <Typography fontSize="10px">{row.customer?.email}</Typography>
              </Stack>
            },
            {
              label: "Status",
              key: "status",
              customValue: (row) => <OrderStatusChip order={row} />
            },
            {
              label: "Revenue / Total",
              key: "total_price_dollars",
              customValue: (row) => <Typography>${row.total_revenue_dollars} / ${row.grand_total_price_dollars}</Typography>
            },
            {
              label: "Created At",
              key: "created_at",
              customValue: (row) => <Typography>{format(new Date(row.created_at), 'yyyy-MM-dd @ h:mm aa')}</Typography>
            },
            {
              label: "Paid At",
              key: "payment_confirmed_at",
              customValue: (row) => <Typography>{row.payment_confirmed_at ? format(new Date(row.payment_confirmed_at), 'yyyy-MM-dd @ h:mm aa') : '-'}</Typography>
            },
            {
              label: "Source",
              key: "is_backend",
              customValue: (row) => <Typography>{row.is_backend ? "Admin" : "Public"}</Typography>
            },
            {
              label: "Actions",
              customValue: (row) => (
                <Stack direction="row">
                  <IconButton onClick={() => navigate(`/orders/${row.id}`)}>
                    <Edit />
                  </IconButton>
                  {row.deletable && <DeleteConfirmation handleDelete={() => handleDelete(row)}>
                    <IconButton>
                      <Delete />
                    </IconButton>
                  </DeleteConfirmation>}
                </Stack>
              )
            }
          ]}
          data={filteredOrders}
        />
      </Stack>
    </Stack>
  );
}